if (!customElements.get('pb40-afterpay')) {
  customElements.define('pb40-afterpay', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.product__info-container');
      this.placement = this.querySelector('afterpay-placement');
      const data = this.querySelector('[data-afterpay-variants]');
      if (!this.root || !this.placement || !data) return;
      this.prices = JSON.parse(data.textContent);
      this.sync = () => {
        const variant = this.root.querySelector('form[action*="/cart/add"] input[name="id"]');
        const amount = this.prices[variant?.value];
        if (amount !== undefined && this.placement.dataset.amount !== String(amount)) {
          this.placement.dataset.amount = String(amount);
        }
      };
      this.root.addEventListener('change', this.sync);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.root, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'checked'] });
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.root?.removeEventListener('change', this.sync);
    }
  });
}
